import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { useLanguage } from '../contexts/LanguageContext';
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext';
import config from '../config/config';
import FaqItem from '../components/FaqItem';
import { useAuth } from '../contexts/AuthContext';

const { apiUrl } = config; 
const apiPath = `${apiUrl}faq`;

function FaqList({ refreshList }) {
    const { t } = useLanguage();
    const [items, setItems] = useState([]);
    const { website, setIsLoading } = useWebsite();
    const { token } = useAuth();

    // Get items from API
    const fetchItems = async () => {
        try {
            const response = await axios.get(`${apiPath}?website=${website}`);
            setItems(response.data);
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'),'error');
        }
    };

    useEffect(() => {
        fetchItems();
    }, [refreshList]);
    
    const handleDelete = async (itemId) => {
        setIsLoading(true);
        try {
            await axios.delete(`${apiPath}/${itemId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            fetchItems();
            setFlashMessage(t('SUCCESS_DELETED_MESSAGE'),'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'),'error');
        }
        setIsLoading(false);
    };
    
    const handleRankingUpdate = async (direction, itemId) => {
        setIsLoading(true);
        try {
            await axios.put(
                `${apiPath}/${itemId}`,
                { ranking: direction }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            fetchItems();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
        setIsLoading(false);
    };

    const handleEdit = async (itemId, editedFaq) => {
        setIsLoading(true);
        try {
            await axios.put(
                `${apiPath}/${itemId}`,
                editedFaq, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            fetchItems();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
        setIsLoading(false);
    };

    return (
        <>
{items.map((faq, index) => (
    <FaqItem 
        key={faq.id} 
        faq={faq} 
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        handleRankingUpdate={handleRankingUpdate}
        isFirst={index === 0}
        isLast={index === items.length - 1}
    />
))}
        </>
    );
}

export default FaqList;
